import { ITreeNode, Tree } from "@blueprintjs/core";
import { useApiEffect, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

import { BreedGroupBreedApi, BreedGroupBreedHierarchySearch } from "../../../../../api";
import { useApiService } from "../../../../../hooks";
import { JudgeLabel } from "./JudgeLabel";

export interface IPersonJudgeHierarchyProps {
  personId: number;
  doUpdate: string;
}

const Container = styled.div`
  border: solid 1px rgba(16, 22, 26, 0.15);

  /* TODO: change this to 100% when pagebase is fixed */
  /* height: 700px; */
`;
export const PersonJudgeHierarchyPage: React.FunctionComponent<IPersonJudgeHierarchyProps> = ({
  personId,
  doUpdate,
}) => {
  const [treeData, setTreeData] = React.useState<ITreeNode[]>([]);
  const api = useApiService(BreedGroupBreedApi);
  const [hierarchyData, hierarchyLoading] = useApiEffect(
    () => api.hierarchy(BreedGroupBreedHierarchySearch.fromJS({ personId: personId })),
    [personId]
  );
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: true,
    sortKeys: { breedGroupNumber: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: BreedGroupBreedHierarchySearch) =>
      api.hierarchy(
        BreedGroupBreedHierarchySearch.fromJS({
          ...sObj,
          personId: personId,
        })
      ),
    [api, personId]
  );

  const { search: refreshHierarchyData } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  React.useEffect(() => {
    if (treeData?.length > 0) return;
    if (!hierarchyLoading) {
      hierarchyData?.results?.map((breedGroup) => {
        let breedGroupTreeNode: ITreeNode = { id: breedGroup.breedGroupId, label: "" };
        breedGroupTreeNode.icon = false;
        breedGroupTreeNode.isExpanded = false;
        breedGroupTreeNode.label = (
          <JudgeLabel judges={breedGroup.breedGroupsJudges} translations={[breedGroup.breedGroupFullName]} />
        );

        let childNodes: ITreeNode[] = [];
        breedGroupTreeNode.childNodes = childNodes;
        if (breedGroup.breeds) {
          breedGroup?.breeds?.map((breed) => {
            let breedTreeNode: ITreeNode = { id: breed.breedId, label: "" };
            breedTreeNode.icon = false;
            breedTreeNode.isExpanded = false;
            breedTreeNode.label = (
              <JudgeLabel judges={breed.breedsJudges} translations={breed.breedTranslations.map((c) => c.text)} />
            );
            if (breed.breedsJudges?.length > 0) {
              breedGroupTreeNode.isExpanded = true;
            }
            childNodes.push(breedTreeNode);
          });
        }
        treeData.push(breedGroupTreeNode);
      });
    }
  }, [hierarchyData?.results, hierarchyLoading, treeData]);

  React.useEffect(() => {
    refreshHierarchyData();
  }, [doUpdate, refreshHierarchyData]);

  const toggleNodeCollapse = React.useCallback(
    (nodeData: ITreeNode) => {
      var clickedNode = treeData.findIndex((c) => c.id === nodeData.id);
      treeData[clickedNode] = { ...treeData[clickedNode], isExpanded: !treeData[clickedNode].isExpanded };
      setTreeData([...treeData]);
    },
    [treeData]
  );

  return (
    <>
      <Container>
        {/* <Tree contents={treeData} onNodeCollapse={toggleNodeCollapse} onNodeExpand={toggleNodeCollapse} /> */}
      </Container>
    </>
  );
};
